export const ACCESS_TOKEN_COOKIE_KEY = 'accessToken';
export const REFRESH_TOKEN_COOKIE_KEY = 'refreshToken';
export const REFRESH_ATTEMPT_SESSION_KEY = 'refreshAttemptKey';
